import Super from 'client-portal/controllers/-request/information';
import classic from 'ember-classic-decorator';

@classic
export default class WidgetInformationIndex extends Super {}
